import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import s from './VisuallyHidden.scss';
/*
  Sometimes we need to include elements for accessibility reasons
  but design doesn't like those elements. So we use this component to
  make the element accessible to a screen reader, but hidden visually.
*/ const VisuallyHidden = (_param)=>{
    var { tag ='span' , children  } = _param, rest = _object_without_properties(_param, [
        "tag",
        "children"
    ]);
    const Component = tag;
    return /*#__PURE__*/ React.createElement(Component, _extends({
        className: s['root']
    }, rest), children);
};
VisuallyHidden.displayName = 'VisuallyHidden';
export default VisuallyHidden;
